import angular from 'angular';

const directiveModule = angular.module('tinaba.directives.isPrice', [])
    .directive('isPrice', () => { // eslint-disable-line
      return {
        require: '?ngModel',
        link: (scope, element, attrs, ngModelCtrl) => {
          if (!ngModelCtrl) {
            return;
          }

          ngModelCtrl.$parsers.push((val) => {
            if (angular.isUndefined(val)) {
             val = ''; // eslint-disable-line
            }

            let clean = val.replace(/[^0-9\,\.]/g, '').replace(".",","); // eslint-disable-line

            // GESTIONE del CARATTERE Virgola "," (Mattia A.)
            if (clean.indexOf(',') !== -1) {
              const commaCheck = clean.split(',');
              const secondPart = commaCheck[1].length > 2 ? commaCheck[1].slice(0, 2) : commaCheck[1];
              const firstPart = commaCheck[0].length ? commaCheck[0] : '0';
              clean = firstPart + ',' + secondPart; // eslint-disable-line
              if (!angular.isUndefined(commaCheck[2])) {
                clean = clean + commaCheck[2];
              }
            }
            if (clean.length > 5 && clean.indexOf(',') === -1) {
              clean = clean.slice(0, -1);
            }
            if (val !== clean) {
              ngModelCtrl.$setViewValue(clean);
              ngModelCtrl.$render();
            }
            return clean;
          });

          element.bind('keypress', (event) => {
            if (event.keyCode === 32) {
              event.preventDefault();
            }
          });
        }
      };
    });

export default directiveModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/directives/isPrice.js
 **/